import React, { useEffect, useState } from 'react';
import MyAsterSlider from './MyAsterSlider';
import { Link } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import httpRequest from 'src/helpers/httpRequest';
import { IPharmacyObj } from 'src/types/GlobalInterfaces';
import qs from "qs";
import { toast } from 'react-toastify';
import { getToken } from 'src/helpers/helperFunctions';
import { jwtDecode } from 'jwt-decode';

const WebCategoriesBanners: React.FC<{ category: string; loader: boolean; data: { categoryBanner: string; mainCategoryId: string; mainCategoryName: string; }[] }> = ({
    category = "", loader = false, data = []
}) => {
    const token = getToken() || "";
    let decoded: { id: string };
    if (token) {
        decoded = jwtDecode<{ id: string }>(token)
    } else {
        decoded = { id: "" }
    }
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [productList, setProductList] = useState<IPharmacyObj[]>([]);
    const fetchProductByMainCategoryId = async (_id: string) => {
        setIsLoader(true);
        const obj = {
            page: 1,
            limit: 12,
            mainCategoryId: [_id],
            userId: decoded.id, // pending
        };
        const { res, err } = await httpRequest<{ documents: IPharmacyObj[]; }>({ path: `/pharma-inventory/home/getPharmaProducts?${qs.stringify(obj)}` });
        if (res) {
            setProductList(res?.documents || []);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };

    useEffect(() => {
        if (data && data[0]?.mainCategoryId) {
            fetchProductByMainCategoryId(data[0]?.mainCategoryId);
        }
    }, [data]);
    return (
        <>
            {loader ?
                <>
                    <div className='py-4'>
                        <Skeleton variant="rectangular" className="thumbnail-img" height="40vh" />
                    </div>
                    <Skeleton variant="text" />
                </>
                :
                <>
                    <div className='py-4'>
                        <Link to={`/pharmacy/${category}/${data[0]?.mainCategoryId}/view`}>
                            <img
                                className='thumbnail-img'
                                src={`${data[0]?.categoryBanner}`}
                                alt={data[0]?.mainCategoryName || ""}
                            />
                        </Link>
                    </div>
                    <h2 className='font-size-28px font-Poppins-SemiBold theme-color-green'>{data[0]?.mainCategoryName || ""}</h2>
                    <div className='pt-4'>
                        <MyAsterSlider
                            data={productList}
                            loader={isLoader}
                            setUpdatedData={setProductList}
                        />
                    </div>
                </>
            }
        </>
    );
};

export default WebCategoriesBanners;